import { METHOD, request } from "./../../../utils/request";
import { Products } from "./../../api";

async function getAll(params) {
  return request(Products.getAll, METHOD.GET, params);
}
async function getDetails(params) {
  return request(Products.getDetails, METHOD.GET, params);
}
async function getDialog(params) {
  return request(Products.getDialog, METHOD.GET, params);
}

async function add(data) {
  return request(Products.add, METHOD.POST, data);
}
async function update(data) {
  return request(Products.update, METHOD.POST, data);
}

async function changeActivationType(data) {
  return request(Products.changeActivationType, METHOD.POST, data);
}

async function finalDelete(data) {
  return request(Products.finalDelete, METHOD.POST, data);
}
async function deleteImage(data) {
  return request(Products.deleteImage, METHOD.POST, data);
}

export default {
  getAll,
  getDetails,
  getDialog,
  add,
  update,
  changeActivationType,
  finalDelete,
  deleteImage,
};
